import { render, staticRenderFns } from "./ModalShort.vue?vue&type=template&id=ff4ad416&scoped=true&"
import script from "./ModalShort.vue?vue&type=script&lang=js&"
export * from "./ModalShort.vue?vue&type=script&lang=js&"
import style0 from "./ModalShort.vue?vue&type=style&index=0&id=ff4ad416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4ad416",
  null
  
)

export default component.exports